"use client";

import { useState } from "react";
import MobileNav from "./MobileNav";
import CanvasNav from "./CanvasNav";
import type { NavNode, Settings } from "@/lib/dto";

/** The slice of Settings the off-canvas menus read — keeps the serialised
 *  client payload small (the full Settings object is large). */
export type MenuSettings = Pick<
  Settings,
  "company_name" | "contact" | "description" | "social"
> & { custom_fields?: Record<string, string> | null };

/**
 * The only interactive part of the header: the hamburger toggle + the two
 * off-canvas panels it opens. Extracted so `Header` itself can be a server
 * component (static bar, no hydration, no serialised settings/nav payload).
 */
export function MobileMenu({
  settings,
  navItems,
}: {
  settings: MenuSettings;
  navItems: NavNode[];
}) {
  const [open, setOpen] = useState(false);

  return (
    <>
      <button
        type="button"
        aria-label={open ? "Close menu" : "Open menu"}
        aria-expanded={open}
        aria-controls="mobile-navigation"
        className="text-headings inline-flex gap-x-1.5 text-sm font-medium items-center font-display"
        onClick={() => setOpen((v) => !v)}
      >
        <span className="lg:hidden">{open ? "Close" : "Menu"}</span>
        <svg className="h-6 w-6" aria-hidden>
          <use xlinkHref="/icons.svg#navigation" />
        </svg>
      </button>

      <CanvasNav
        open={open}
        onClose={() => setOpen(false)}
        settings={settings}
      />
      <MobileNav
        open={open}
        items={navItems}
        onClose={() => setOpen(false)}
        settings={settings}
      />
    </>
  );
}
